module.exports = __webpack_public_path__ + "img/daniel.8a8e9f30.png";